export enum ScheduleTrainingStatusEnum {
    None = 0,
    Passed = 1,
    Failed = 2,
    Missed = 3
}
